function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1988(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.19,
    height: 15.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8864705882352941
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 7.535,
    fontFamily: "Arial"
  }, "\n        Lake_of_the_Woods\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.07,
    width: 28.19,
    height: 18.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 24.1,
    fontFamily: "Arial"
  }, "\n        Red_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.13,
    width: 28.19,
    height: 18.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 42.2,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51.27,
    width: 28.19,
    height: 19.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 61.06,
    fontFamily: "Arial"
  }, "\n        Mahnomen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70.85,
    width: 28.19,
    height: 20.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 81.13,
    fontFamily: "Arial"
  }, "\n        Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.42,
    width: 28.19,
    height: 25.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6271428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 104.11500000000001,
    fontFamily: "Arial"
  }, "\n        Kittson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 116.81,
    width: 28.19,
    height: 28.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 131.035,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 145.25,
    width: 28.19,
    height: 28.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.698333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 159.565,
    fontFamily: "Arial"
  }, "\n        Wilkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.88,
    width: 28.19,
    height: 29.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1322222222222225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 188.51999999999998,
    fontFamily: "Arial"
  }, "\n        Big_Stone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.17,
    width: 28.19,
    height: 29.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.819
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 217.98499999999999,
    fontFamily: "Arial"
  }, "\n        Clearwater\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 232.79,
    width: 28.19,
    height: 30.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 248.06,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.33,
    width: 28.19,
    height: 32.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.698333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 279.76,
    fontFamily: "Arial"
  }, "\n        Norman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 296.19,
    width: 28.19,
    height: 41.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1684615384615387
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 316.885,
    fontFamily: "Arial"
  }, "\n        Lac_qui_Parle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 337.57,
    width: 28.19,
    height: 43.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1322222222222225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 359.12,
    fontFamily: "Arial"
  }, "\n        Pipestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 380.67,
    width: 28.19,
    height: 43.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.698333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 402.315,
    fontFamily: "Arial"
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 423.96,
    width: 28.19,
    height: 43.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 445.615,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 467.27,
    width: 28.19,
    height: 44.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.52375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 489.755,
    fontFamily: "Arial"
  }, "\n        Watonwan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 512.24,
    width: 28.19,
    height: 45.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 534.905,
    fontFamily: "Arial"
  }, "\n        Stevens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 557.57,
    width: 28.19,
    height: 46.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 580.815,
    fontFamily: "Arial"
  }, "\n        Kanabec\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 604.06,
    width: 28.19,
    height: 47.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 628.04,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 652.03,
    width: 28.19,
    height: 47.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.095,
    y: 676.015,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 0,
    width: 33.68,
    height: 40.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.736
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.03,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Swift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.86,
    y: 0,
    width: 33.75,
    height: 40.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.21875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 78.735,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.62,
    y: 0,
    width: 34.61,
    height: 40.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.944285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.92500000000001,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.23,
    y: 0,
    width: 35.26,
    height: 40.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.85999999999999,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Pennington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.5,
    y: 0,
    width: 35.97,
    height: 40.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.485,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Roseau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 0,
    width: 36.47,
    height: 40.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4313333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.70499999999998,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Yellow_Medicine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.93,
    y: 0,
    width: 36.59,
    height: 40.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.225,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Wadena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.52,
    y: 0,
    width: 37.84,
    height: 40.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.44,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.36,
    y: 0,
    width: 38.02,
    height: 40.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8020000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.37,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Cottonwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.38,
    y: 0,
    width: 39.38,
    height: 40.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.07,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Koochiching\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.76,
    y: 0,
    width: 39.77,
    height: 40.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.954000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 409.645,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.53,
    y: 0,
    width: 40.31,
    height: 40.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.68499999999995,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Sibley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.84,
    y: 0,
    width: 40.32,
    height: 40.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Aitkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.16,
    y: 0,
    width: 44.94,
    height: 40.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.757142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.63,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Hubbard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.1,
    y: 0,
    width: 48.14,
    height: 40.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.1700000000001,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Waseca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.23,
    y: 0,
    width: 48.22,
    height: 40.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.029999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.34,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Mille_Lacs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.45,
    y: 0,
    width: 48.55,
    height: 40.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.757142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.725,
    y: 20.15,
    fontFamily: "Arial"
  }, "\n        Redwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 40.3,
    width: 49.78,
    height: 41.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.597777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 60.989999999999995,
    fontFamily: "Arial"
  }, "\n        Faribault\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 81.68,
    width: 49.78,
    height: 41.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.928571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 102.43,
    fontFamily: "Arial"
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 123.18,
    width: 49.78,
    height: 41.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 144.17000000000002,
    fontFamily: "Arial"
  }, "\n        Renville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 165.15,
    width: 49.78,
    height: 43.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 186.78,
    fontFamily: "Arial"
  }, "\n        Fillmore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 208.42,
    width: 49.78,
    height: 43.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 230.08499999999998,
    fontFamily: "Arial"
  }, "\n        Wabasha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 251.75,
    width: 49.78,
    height: 44.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.361666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 273.835,
    fontFamily: "Arial"
  }, "\n        Nobles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 295.92,
    width: 49.78,
    height: 44.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 318.285,
    fontFamily: "Arial"
  }, "\n        Pine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 340.65,
    width: 49.78,
    height: 45.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6066666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 363.46999999999997,
    fontFamily: "Arial"
  }, "\n        Meeker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 386.3,
    width: 49.78,
    height: 50.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 411.53000000000003,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 436.76,
    width: 49.78,
    height: 50.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 462.03499999999997,
    fontFamily: "Arial"
  }, "\n        Todd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 487.31,
    width: 49.78,
    height: 51.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 512.995,
    fontFamily: "Arial"
  }, "\n        Le_Sueur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 538.68,
    width: 49.78,
    height: 52.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 564.8199999999999,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 590.96,
    width: 49.78,
    height: 53.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 617.885,
    fontFamily: "Arial"
  }, "\n        Isanti\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 644.81,
    width: 49.78,
    height: 55.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.08,
    y: 672.405,
    fontFamily: "Arial"
  }, "\n        Lyon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 40.3,
    width: 50.84,
    height: 55.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.39,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Benton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.81,
    y: 40.3,
    width: 51.4,
    height: 55.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.51,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.22,
    y: 40.3,
    width: 53.42,
    height: 55.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.903333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.93,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Becker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.64,
    y: 40.3,
    width: 55.85,
    height: 55.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.565,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Morrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.49,
    y: 40.3,
    width: 57.26,
    height: 55.44,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.12,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Carlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.75,
    y: 40.3,
    width: 57.47,
    height: 55.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.485,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Steele\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.22,
    y: 40.3,
    width: 58.19,
    height: 55.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.31500000000005,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Nicollet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.41,
    y: 40.3,
    width: 58.49,
    height: 55.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.65500000000003,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.9,
    y: 40.3,
    width: 58.54,
    height: 55.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.17,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        McLeod\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.44,
    y: 40.3,
    width: 59.84,
    height: 55.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.36,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Chisago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.28,
    y: 40.3,
    width: 60.72,
    height: 55.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.64,
    y: 68.02,
    fontFamily: "Arial"
  }, "\n        Beltrami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 95.74,
    width: 63.75,
    height: 53.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 122.66,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 149.57,
    width: 63.75,
    height: 59.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.44375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 179.345,
    fontFamily: "Arial"
  }, "\n        Freeborn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 209.13,
    width: 63.75,
    height: 60.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.732222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 239.425,
    fontFamily: "Arial"
  }, "\n        Sherburne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 269.72,
    width: 63.75,
    height: 65.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.083333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 302.51500000000004,
    fontFamily: "Arial"
  }, "\n        Kandiyohi\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 335.31,
    width: 63.75,
    height: 69.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 370.24,
    fontFamily: "Arial"
  }, "\n        Mower\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 405.17,
    width: 63.75,
    height: 69.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 440.15000000000003,
    fontFamily: "Arial"
  }, "\n        Itasca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 475.13,
    width: 63.75,
    height: 70.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.107142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 510.2,
    fontFamily: "Arial"
  }, "\n        Goodhue\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 545.27,
    width: 63.75,
    height: 76.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.083333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 583.66,
    fontFamily: "Arial"
  }, "\n        Crow_Wing\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.97,
    y: 622.05,
    width: 63.75,
    height: 77.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.845,
    y: 661.025,
    fontFamily: "Arial"
  }, "\n        Carver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.72,
    y: 95.74,
    width: 70.68,
    height: 70.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.06,
    y: 130.95999999999998,
    fontFamily: "Arial"
  }, "\n        Rice\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.4,
    y: 95.74,
    width: 71.87,
    height: 70.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.335,
    y: 130.95999999999998,
    fontFamily: "Arial"
  }, "\n        Winona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.27,
    y: 95.74,
    width: 72.14,
    height: 70.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.34,
    y: 130.95999999999998,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.41,
    y: 95.74,
    width: 81.6,
    height: 70.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.21000000000004,
    y: 130.95999999999998,
    fontFamily: "Arial"
  }, "\n        Blue_Earth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 95.74,
    width: 81.77,
    height: 70.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.885,
    y: 130.95999999999998,
    fontFamily: "Arial"
  }, "\n        Otter_Tail\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.77,
    y: 95.74,
    width: 82.04,
    height: 70.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.088
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.79,
    y: 130.95999999999998,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.81,
    y: 95.74,
    width: 98.19,
    height: 70.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.905,
    y: 130.95999999999998,
    fontFamily: "Arial"
  }, "\n        Wright\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.72,
    y: 166.17,
    width: 118.07,
    height: 94.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.454285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.755,
    y: 213.26,
    fontFamily: "Arial"
  }, "\n        Olmsted\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.72,
    y: 260.36,
    width: 118.07,
    height: 103.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.754285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.755,
    y: 312,
    fontFamily: "Arial"
  }, "\n        Stearns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.72,
    y: 363.64,
    width: 118.07,
    height: 131.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.806999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.755,
    y: 429.48,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.72,
    y: 495.32,
    width: 118.07,
    height: 204.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.733636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.755,
    y: 597.66,
    fontFamily: "Arial"
  }, "\n        Saint_Louis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.79,
    y: 166.17,
    width: 202.17,
    height: 122.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.503999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.875,
    y: 227.42999999999998,
    fontFamily: "Arial"
  }, "\n        Anoka\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.96,
    y: 166.17,
    width: 238.04,
    height: 122.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.419999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.98,
    y: 227.42999999999998,
    fontFamily: "Arial"
  }, "\n        Dakota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.79,
    y: 288.69,
    width: 133.69,
    height: 411.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.281666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.635,
    y: 494.345,
    fontFamily: "Arial"
  }, "\n        Ramsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.48,
    y: 288.69,
    width: 306.52,
    height: 411.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.74,
    y: 494.345,
    fontFamily: "Arial"
  }, "\n        Hennepin\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1988);
export default __webpack_public_path__ + "static/media/1988.d2496bdc56ab32fce306f0d33180541b.svg";
export { ForwardRef as ReactComponent };